export enum OpportunityTypes {
	Board = 'board positions',
	Volunteer = 'volunteer programs',
	Membership = 'membership groups',
	Group = 'group activities',
	Sponsorship = 'sponsorship opportunities'
}
export enum OpportunitySubType {
	associateBoard = 'associate board',
	governingBoard = 'governing board',
	advisoryBoard = 'advisory board',
	mentor = 'mentor',
	volunteer = 'volunteer',
	other= 'other',
	membershipGroup = 'membership group'
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/components/nonprofitProfile/components/mainPanel/components/opportunity/components/opportunityAddEdit/models/enums/opportunityTypes.ts